var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1529",
    "data-name": "Group 1529",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.983,
    height: 24.03,
    viewBox: "0 0 16.983 24.03",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M191.911,44.359h0a8.491,8.491,0,0,0-8.491,8.491h0a8.491,8.491,0,0,0,1.38,4.64l7.111,10.9h0l7.111-10.9a8.492,8.492,0,0,0,1.38-4.64h0A8.491,8.491,0,0,0,191.911,44.359Zm0,12.935a4.513,4.513,0,1,1,4.513-4.513A4.513,4.513,0,0,1,191.911,57.294Z",
    transform: "translate(-183.419 -44.359)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMenu);
export default __webpack_public_path__ + "static/media/home-menu.0428ae63.svg";
export { ForwardRef as ReactComponent };